/**
 * Keyboard shortcuts hook
 *
 * Replaces the legacy KeyboardShortcuts singleton with a React hook.
 * Skips shortcuts when focus is in input/textarea elements.
 */
import { useEffect } from 'react';
import { useBuilderStore } from '@/state/store';
import { Toast } from '@/state/toast';

export function useKeyboardShortcuts() {
  const temporalStore = useBuilderStore.temporal;

  useEffect(() => {
    function getKeyString(e: KeyboardEvent): string {
      const parts: string[] = [];
      if (e.ctrlKey || e.metaKey) parts.push('ctrl');
      if (e.shiftKey) parts.push('shift');
      if (e.altKey) parts.push('alt');
      parts.push(e.key.toLowerCase());
      return parts.join('+');
    }

    function handleKeyDown(e: KeyboardEvent) {
      // Skip if typing in input/textarea
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      const key = getKeyString(e);

      switch (key) {
        case 'ctrl+z': {
          e.preventDefault();
          const { undo } = temporalStore.getState();
          undo();
          break;
        }
        case 'ctrl+y':
        case 'ctrl+shift+z': {
          e.preventDefault();
          const { redo } = temporalStore.getState();
          redo();
          break;
        }
        case 'ctrl+s': {
          e.preventDefault();
          Toast.success('Automatisch gespeichert');
          break;
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [temporalStore]);
}
